import { Injectable,ViewContainerRef  } from '@angular/core';
// import { ToastrService } from ;
import { ToastrManager } from 'ng6-toastr-notifications';



@Injectable()

export class Notification{
   constructor(private toastr:ToastrManager){ 
   }
     
   Success(title:string,message?:string){
    this.toastr.successToastr(title,message);
    }

    Error(title:string,message?:string){
      this.toastr.errorToastr(title,message);
    }

    Info(title:string,message?:string){
      this.toastr.infoToastr(title,message);
    }
    Warning(title:string,message?:string){
      this.toastr.warningToastr(title,message);
    }

    showToast(position: any = 'top-left') {
        this.toastr.infoToastr('This is a toast.', 'Toast', { position: position });
    }

} 